<template>
  <div class="container-title-page">

    <div class="flex-grow-1 title-page">{{ title }}</div>

    <div class="header-buttons">

      <slot>


      </slot>

    </div>

  </div>
</template>
<style>


</style>
<script>
export default {
  name: 't-page-title',
  props: {
    title: {}
  }
}
</script>
